<template>
    <div class="plano_modal" v-show="visible">
        <main v-if="datas">
            <img src="../../assets/croix.png" width="40" height="40" alt @click="validate();" class="cross fright abs pointer" />
            <h1>{{ $t("plano.infoModal.informationPlanogramTitle") }}</h1>
            <p>
                {{ $t("plano.infoModal.name") }} : <span>{{ datas.name }}</span>
            </p>
            <p v-if="datas.zone && datas.zone.name">
                {{ $t("plano.infoModal.zone") }} : <span>{{ datas.zone.name }}</span>
            </p>
            <p v-if="datas.zones">
                {{ $t("plano.infoModal.zone") }}s : <span v-for="zone in datas.zones" :key="zone.id">{{ zone.name }}</span>
            </p>
            <p>
                {{ $t("plano.infoModal.designAndCampaign") }} :
                <span>{{ standDesign && standDesign.name }} {{ datas.campaign && "/ " + datas.campaign.name }}</span>
            </p>
            <p>
                {{ $t("plano.infoModal.size") }} :
                <span>{{ datas.height || datas.heightExternal }} mm X {{ datas.width || datas.widthExternal }} mm</span>
            </p>
            <p>
                {{ $t("plano.infoModal.type") }} :
                <span>
                    {{
                        getTranslate(
                            systemTypeObject &&
                                systemTypeObject.systemType &&
                                systemTypeObject.systemType.terms &&
                                systemTypeObject.systemType.terms.name
                        )
                    }}
                </span>
            </p>
            <p v-if="datas.template">
                {{ $trad.templatePlano.template }}: <span> {{ datas.template.name }} </span>
            </p>
            <br />
            <p>
                {{ $t("plano.infoModal.createdOn") }} <span>{{ datas.createdAt || (datas.createdUser && datas.createdUser.dateCreated) }}</span>
                {{ $t("common.by") }} <span>{{ createdBy }}</span>
            </p>
            <p>
                {{ $t("plano.infoModal.modifiedOn") }}
                <span>{{ datas.modifiedDate || (datas.modifiedUser && datas.modifiedUser.modifiedDate) }}</span> {{ $t("common.by") }}
                <span>{{ modifiedBy }}</span>
            </p>
        </main>
    </div>
</template>

<script>
let displayInfoWidget;
window.displayInfo = function displayInfo(data, onValidate, onCancel) {
    if (!displayInfoWidget) {
        onCancel();
        return;
    }
    displayInfoWidget.visible = true;
    displayInfoWidget.onValidate = onValidate;
};

export default {
    data() {
        return {
            visible: false,
            onValidate: undefined
        };
    },
    props: {
        datas: {
            type: Object,
            required: false
        }
    },
    computed: {
        createdBy() {
            return this.datas && this.datas.createdUser && this.datas.createdUser.firstname + " " + this.datas.createdUser.lastname;
        },
        modifiedBy() {
            return this.datas && this.datas.modifiedUser && this.datas.modifiedUser.firstname + " " + this.datas.modifiedUser.lastname;
        },
        systemTypeObject() {
            return this.datas && (this.datas.template || this.datas);
        },
        standDesign() {
            return this.datas.stand_design || this.datas.standDesign;
        }
    },
    created() {
        displayInfoWidget = this;
    },
    methods: {
        validate() {
            this.onValidate({});
            this.visible = false;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes";
.plano_modal {
    text-align: center;
    color: #777;
    h1 {
        font-family: Oswald, Sans-Serif;
        font-size: 18px;
        text-transform: uppercase;
    }
    main {
        position: relative;
        top: 50%;
        transform: translate(0, -50%);
        border-radius: 10px;
        padding: 20px;
        background-color: #fff;
        display: inline-block;
        vert-align: middle;
        text-align: left;
        .cross {
            top: 10px;
            right: 10px;
        }
        p {
            font-family: Roboto, sans-serif;
            margin: 2px 0px;
            font-size: 13px;
            text-transform: lowercase;
            span {
                color: $color2;
                text-transform: unset;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// display_info.vue?66d34dce